// extracted by mini-css-extract-plugin
export default {"table":"SearchResults-module__table___aa9vj"};